var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-surveys"},[_c('transition',{attrs:{"name":"van-fade","mode":"out-in"}},[_c('router-view',{ref:"routerView"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }